<template>
  <div class="mm-page-main" v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">歷史記錄</div>

    </div>
    <search :form="form" @submit="getraterecodes"></search>
    <div style="height: 20px;">

    </div>
    <div v-if="stores.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.short}} {{store.name}}</li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div class="table-header mb10">
          <el-radio-group v-model="form.recordtype">
            <el-radio-button label="0">貨幣管理</el-radio-button>
            <el-radio-button label="1">匯率/手續費設置</el-radio-button>
          </el-radio-group>
        </div>
        <div class="pagetablebox">
          <el-table v-loading="loading" empty-text="暫無數據" :data="data" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="name" label="貨幣" align="center" >
              <template slot-scope="scope">
                <div class="phonecel">貨幣</div>
                <div style="display: flex; align-items: center; ">
                  <div><img style="display: block; width: 30px; height: 30px;" :src="apiurl+scope.row.currency_thumb"></div>
                  <div style="margin-left: 10px;">{{scope.row.currency_short_name}}</div>
                  <div style="margin-left: 10px;">{{scope.row.currency_name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="變更前">
              <template slot-scope="scope">
                <div class="phonecel">變更前</div>
                <div v-if="form.recordtype==0" style="padding:0 15px">
                  <p v-if="scope.row.old_record.type1!=scope.row.new_record.type1">業務：<el-switch v-model="scope.row.old_record.type1" :disabled="true" active-text="啟用" inactive-text="禁用"></el-switch>
                  </p>
                  <p v-if="scope.row.old_record.type2!=scope.row.new_record.type2">大屏幕：<el-switch v-model="scope.row.old_record.type2" :disabled="true" active-text="啟用" inactive-text="禁用"></el-switch>
                  </p>
                  <p v-if="scope.row.old_record.type3!=scope.row.new_record.type3">使用除法：<el-switch v-model="scope.row.old_record.type3" :disabled="true" active-text="啟用" inactive-text="禁用"></el-switch>
                  </p>
                  <p v-if="scope.row.old_record.type4!=scope.row.new_record.type4">計算成本：<el-switch v-model="scope.row.old_record.type4" :disabled="true" active-text="自動" inactive-text="手動"></el-switch>
                  </p>
                </div>
                <div v-if="form.recordtype==1" style="padding:0 15px">
                  <p v-if="scope.row.new_rate.buyrate!=scope.row.old_rate.buyrate">買入：{{scope.row.old_rate.buyrate}}</p>
                  <p v-if="scope.row.new_rate.sellrate!=scope.row.old_rate.sellrate">賣出：{{scope.row.old_rate.sellrate}}</p>
                  <p v-if="scope.row.new_rate.costrate!=scope.row.old_rate.costrate">成本：{{scope.row.old_rate.costrate}}</p>
                  <p v-if="scope.row.new_rate.fee&&(scope.row.new_rate.fee!=scope.row.old_rate.fee)">手續費：{{scope.row.old_rate.fee}}</p>
                  <p v-if="scope.row.new_rate.fee_type&&(scope.row.new_rate.fee_type!=scope.row.old_rate.fee_type)">手續費貨幣：{{scope.row.old_rate.fee_type==0?scope.row.currency_short_name:'HKD'}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="變更后">
              <template slot-scope="scope">
                <div class="phonecel">變更后</div>
                <div v-if="form.recordtype==0" style="padding:0 15px">
                  <p v-if="scope.row.old_record.type1!=scope.row.new_record.type1">業務：<el-switch v-model="scope.row.new_record.type1" :disabled="true" active-text="啟用" inactive-text="禁用"></el-switch>
                  </p>
                  <p v-if="scope.row.old_record.type2!=scope.row.new_record.type2">大屏幕：<el-switch v-model="scope.row.new_record.type2" :disabled="true" active-text="啟用" inactive-text="禁用"></el-switch>
                  </p>
                  <p v-if="scope.row.old_record.type3!=scope.row.new_record.type3">使用除法：<el-switch v-model="scope.row.new_record.type3" :disabled="true" active-text="啟用" inactive-text="禁用"></el-switch>
                  </p>
                  <p v-if="scope.row.old_record.type4!=scope.row.new_record.type4">計算成本：<el-switch v-model="scope.row.new_record.type4" :disabled="true" active-text="自動" inactive-text="手動"></el-switch>
                  </p>
                </div>
                <div v-if="form.recordtype==1" style="padding:0 15px">
                  <p v-if="scope.row.new_rate.buyrate!=scope.row.old_rate.buyrate">買入：{{scope.row.new_rate.buyrate}}</p>
                  <p v-if="scope.row.new_rate.sellrate!=scope.row.old_rate.sellrate">賣出：{{scope.row.new_rate.sellrate}}</p>
                  <p v-if="scope.row.new_rate.costrate!=scope.row.old_rate.costrate">成本：{{scope.row.new_rate.costrate}}</p>
                  <p v-if="scope.row.new_rate.fee&&(scope.row.new_rate.fee!=scope.row.old_rate.fee)">手續費：{{scope.row.new_rate.fee}}</p>
                  <p v-if="scope.row.new_rate.fee_type&&(scope.row.new_rate.fee_type!=scope.row.old_rate.fee_type)">手續費貨幣：{{scope.row.new_rate.fee_type==0?scope.row.currency_short_name:'HKD'}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="類別" align="center" >
              <template slot-scope="scope">
                <div class="phonecel">類別</div>
                <span>{{scope.row.type==0?'現金':'匯款'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="addtime" label="日期" align="center" >
              <template slot-scope="scope">
                <div class="phonecel">日期</div>
                <span>{{scope.row.addtime}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作同事" align="center" >
              <template slot-scope="scope">
                <div class="phonecel">操作同事</div>
                <span>{{scope.row.username}}({{scope.row.operator}})</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page-bottom">
          <div>
          </div>
          <div>
            <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
            </el-pagination>
          </div>
          <div>
            Total: {{pager.p_count}} 條記錄
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import search from "./components/Search.vue";
export default {
  components: {
    search
  },
  data () {
    return {
      mso_id: 0,
      loading: true,
      is_init: true,
      store_id: 0,
      stores: [],
      initpage: 0,
      form: {
        currency: [],
        type: "-1",
        currency_id: "-1",
        starttime: '',
        endtime: '',
        recordtype: '0',
        sortname:'addtime',
        orderby:'DESC',
      },
      data: [],
      page: 1,
      pagesize: 10,
      pager: [],
      transform: '',
      transformnum: 0,
    }
  },
  methods: {
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    async getCurrency () {
      // 获取货币
      let store_id = this.store_id;
      await this.post('/api/rate/currencylist', {})
        .then(response => {
          let currency = this.form.currency = response;
          // 默认 设置
          if (this.is_init) {
            // currency.some(item => {
            //   if (item.short_name == 'HKD') {
            //     this.form.currency_id = item.id;
            //   }
            // })
            this.is_init = false;
          }

        }).catch(error => {
          console.log(error);
        })
    },
    getraterecodes () {
      this.loading = true;
      let form = this.form;
      if (this.initpage != form.recordtype) {
        this.page = 1;
        this.initpage = form.recordtype;
      }
      this.data = [];
      this.pager = [];
      this.post('/api/rate/getraterecodes', {
        store_id: this.store_id,
        page: this.page,
        pagesize: this.pagesize,
        currency_id: form.currency_id,
        type: form.type,
        starttime: form.starttime,
        endtime: form.endtime,
        recordtype: form.recordtype,
        orderby:form.orderby,
        sortname:form.sortname,
      }).then((res) => {
        if (res.info.length > 0) {
          if (this.form.recordtype == 0) {
            let info = res.info;
            info.map(item => {
              if (item.old_record.type1 == 0) {
                item.old_record.type1 = false;
              } else if (item.old_record.type1 == 1) {
                item.old_record.type1 = true;
              }
              if (item.old_record.type2 == 0) {
                item.old_record.type2 = false;

              } else if (item.old_record.type2 == 1) {
                item.old_record.type2 = true;
              }
              if (item.old_record.type3 == 0) {
                item.old_record.type3 = false;

              } else if (item.old_record.type3 == 1) {
                item.old_record.type3 = true;
              }
              if (item.old_record.type4 == 0) {
                item.old_record.type4 = false;
              } else if (item.old_record.type4 == 1) {
                item.old_record.type4 = true;
              }
              // 新數據
              if (item.new_record.type1 == 0) {
                item.new_record.type1 = false;
              } else if (item.new_record.type1 == 1) {
                item.new_record.type1 = true;
              }
              if (item.new_record.type2 == 0) {
                item.new_record.type2 = false;
              } else if (item.new_record.type2 == 1) {
                item.new_record.type2 = true;
              }
              if (item.new_record.type3 == 0) {
                item.new_record.type3 = false;
              } else if (item.new_record.type3 == 1) {
                item.new_record.type3 = true;
              }
              if (item.new_record.type4 == 0) {
                item.new_record.type4 = false;
              } else if (item.new_record.type4 == 1) {
                item.new_record.type4 = true;
              }
            });
          }
          this.data = res.info;
          this.pager = res.pager;
          this.page = 1;
        }
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {

      })
    },

    changeordertype () {
      this.getraterecodes();
    },
    changepage (val) {
      this.page = val;
      this.getraterecodes();
    },
    changesize (val) {
      this.pagesize = val;
      this.getraterecodes();
    },

    changestore (store_id) {
      this.store_id = store_id;
      this.page = 1;
      this.getraterecodes();

    },

    gotoruter (name) {
      this.$router.push(name)
    },
    async getstore () {
      this.loading = true;
      this.post('/api/rate/getstore', {
      }).then((res) => {
        if (res.length > 0) {
          this.store_id = res[0].id;
        }
        this.stores = res;
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(async () => {
        await this.getCurrency(); // 獲取貨幣
        this.getraterecodes(); // 獲取記錄
      })


    }

  },
  created () {
    this.mso_id = this.sessionRead('mso_id');
    this.getstore();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.getraterecodes();
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.pagetablebox {
  padding: 20px 0;
}
.textred {
  color: red;
}
.textblue {
  color: blue;
}
</style>
